<template>
  <top-bar
    v-if="mode"
    :color="mode === 'restored' ? 'success' : 'error'"
  >
    <subscription-expiring-bar
      v-if="mode === 'expiring'"
      :promised-pending="promisedPending"
    />
    <connection-message
      v-else
      :mode="mode"
    />
  </top-bar>
</template>

<script>
  import { mapState } from 'vuex'
  import TopBar from './TopBar.vue'
  import SubscriptionExpiringBar from '@/components/billing/SubscriptionExpiringBar.vue'
  import ConnectionMessage from '@/components/connection/ConnectionMessage.vue'
  import { connectionMode, topBarMode, expiringBarVisible, connectionBarHidden, RESTORED_SHOW_MS } from '@/util/top-bar-mode'
  import { SOCKET_LOST_BAR_ENABLED } from '@/constants/connection-bar'

  export default {
    name: 'AppTopBar',
    components: { TopBar, SubscriptionExpiringBar, ConnectionMessage },
    props: {
      loggedIn: {
        type: Boolean,
        default: false,
      },
    },
    data () {
      return {
        now: Date.now(),
        ticker: null,
        restored: false,
        restoredTimer: null,
      }
    },
    computed: {
      ...mapState('network', ['online', 'serverUnavailable']),
      ...mapState('ws', {
        wsConnected: 'connected',
        disconnectedSince: 'disconnectedSince',
      }),
      ...mapState('billing', ['paymentAccount']),
      showExpiring () {
        return expiringBarVisible({
          paymentAccount: this.paymentAccount,
          isSuperAdmin: this.isSuperAdmin,
          layout: this.$route.meta.layout,
          routeName: this.$route.name,
        })
      },
      promisedPending () {
        const promisedPayment = this.paymentAccount.promisedPayment
        return Boolean(promisedPayment && promisedPayment.pending)
      },
      connectionHidden () {
        return connectionBarHidden(this.$route.meta.layout, this.$route.name)
      },
      connectionMode () {
        return connectionMode({
          online: this.online,
          loggedIn: this.loggedIn,
          wsConnected: this.wsConnected,
          disconnectedSince: this.disconnectedSince,
          serverUnavailable: this.serverUnavailable,
          now: this.now,
          socketLostBar: SOCKET_LOST_BAR_ENABLED,
        })
      },
      mode () {
        return topBarMode({
          connection: this.connectionMode,
          restored: this.restored,
          expiring: this.showExpiring,
          connectionHidden: this.connectionHidden,
        })
      },
    },
    watch: {
      // Часы нужны только пока сокет лежит и полоса по сокету включена: она появляется
      // через несколько секунд после разрыва, а событие об этом никто не пришлёт
      wsConnected: {
        immediate: true,
        handler (connected) {
          if (connected || !SOCKET_LOST_BAR_ENABLED) {
            this.stopTicking()
          } else {
            this.startTicking()
          }
        },
      },
      // Зелёное «Связь восстановлена» - только если красная полоса была на экране
      connectionMode (mode, previous) {
        clearTimeout(this.restoredTimer)
        this.restored = Boolean(previous) && !mode

        if (this.restored) {
          this.restoredTimer = setTimeout(() => {
            this.restored = false
          }, RESTORED_SHOW_MS)
        }
      },
    },
    beforeDestroy () {
      this.stopTicking()
      clearTimeout(this.restoredTimer)
    },
    methods: {
      startTicking () {
        this.now = Date.now()
        clearInterval(this.ticker)
        this.ticker = setInterval(() => {
          this.now = Date.now()
        }, 1000)
      },
      stopTicking () {
        clearInterval(this.ticker)
        this.ticker = null
      },
    },
  }
</script>
